var map = {
	"./Cool Rock Full.mp3": 529,
	"./Dark Cybernetic World.mp3": 530,
	"./Epic Rock (MP3).mp3": 531,
	"./Epic War Trailer.mp3": 532,
	"./File A 2-11_331 - The Energy (Full).mp3": 533,
	"./Gothic Emotional Suspense Riser (vocal&choir) - AllenGrey.mp3": 534,
	"./Into-Oblivion.mp3": 535,
	"./Lost Voices Soundscape.mp3": 536,
	"./Micrah - Cyberpunk.mp3": 537,
	"./Micrah - Dark Electro (Full Version).mp3": 538,
	"./No Limits.mp3": 539,
	"./Power.mp3": 540,
	"./Sport Future Bass.mp3": 541,
	"./VictorSE - Cyberpunk.mp3": 542,
	"./alex-productions-cyberpunk-computer-game-idra.mp3": 543,
	"./alex-productions-extreme-sport-dubstep-im-back.mp3": 544,
	"./cyberpunk.mp3": 545,
	"./extreme-sport-electro.mp3": 546,
	"./scott-buckley-i-walk-with-ghosts.mp3": 547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 528;